<template lang="pug">
div
  Form(:data="behaviour", :isSubmitting="isSubmitting", @submit="(data, imgFile) => create(data, imgFile)")
</template>

<script>
import Form from '../shared/Form.vue'
import useBehaviourAdd from './useBehaviourAdd'

export default {
  components: {
    Form,
  },

  setup() {
    const { create, behaviour, isSubmitting } = useBehaviourAdd()

    return {
      behaviour,
      create,
      isSubmitting,
    }
  },
}
</script>
